<route-container
  *ngIf="hasRouterOutlet"
  [uid]="uid + '-route-container'"
  [debug]="debug"
  (routerOutletChange)="onChildRouteEvent($event)"
>
  <ng-container [ngTemplateOutlet]="dynamicLoader"></ng-container>
</route-container>

<ng-container *ngIf=!hasRouterOutlet [ngTemplateOutlet]="dynamicLoader"></ng-container>

<ng-template #dynamicLoader>
  <loader-container #loaderContainer
                    [loader]="loader"
                    [uid]="uid + '-loader'"
                    [options]="{
      disableAutoRefresh: loaderOptions.disableAutoRefresh,
      context: loaderOptions.context,
      outerNgClass: loaderOptions.outerNgClass,
      errorTemplate: loaderOptions.errorTemplate,
      loadingTemplate: loaderOptions.loadingTemplate,
      contentTemplate: loaderOptions.contentTemplate || defaultContentTemplate
    }"
                        (loaded)="onLoadComplete($event)"
  ></loader-container>
</ng-template>

<ng-template #defaultContentTemplate let-content=content let-reflectedType=reflectedType>
  <ng-container [ngSwitch]="reflectedType">
    <ng-container
      *ngSwitchCase="'array'"
      [ngTemplateOutlet]="arrayContentTemplate"
      [ngTemplateOutletContext]="{
        content: content,
        reflectedType: reflectedType
      }"
    >
    </ng-container>
    <ng-container
      *ngSwitchCase="'composite'"
      [ngTemplateOutlet]="objectContentTemplate"
      [ngTemplateOutletContext]="{
        content: content,
        reflectedType: reflectedType
      }"
    >
    </ng-container>
    <ng-container *ngSwitchCase="'string'">
      <span [ngClass]="'text-secondary'">{{content}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'date'">
      <span [ngClass]="'text-secondary'">{{content | date}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'boolean'">
      <span class="text-primary" [ngClass]="{
        'text-danger': ! content
        }">{{content}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'number'">
      <span [ngClass]="'text-primary'">{{content}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'bigint'">
      <span [ngClass]="'text-primary'">{{content}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'null'">
      <span class="text-primary">null</span>
    </ng-container>
    <ng-container *ngSwitchCase="'undefined'">
      <span class="text-danger">undefined</span>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <span [ngClass]="'text-secondary'">{{content}}</span>
    </ng-container>

  </ng-container>
</ng-template>

<ng-template #arrayContentTemplate let-content=content>
  <div>
    <quick-preview-panel
      [heading]="heading || 'Results'"
      [color]="color || 'primary'"
      [ngClass]="'mb-4'"
    >
      <div>
        <data-table
          [manualReloadToken]="manualReloadToken"
          [options]="{
            headingNgClass: 'fw-normal',
            rowNgClass: 'fw-light'
          }"
          [items]="content"
          [columnOptions]="columnOptions"
        ></data-table>
      </div>
    </quick-preview-panel>
  </div>
  <actions-container
    *ngIf="!hideActions"
    [ngClass]="'mb-4'">
    <back-button></back-button>
    <manage-button
      *ngIf="!hideManageButton"
    ></manage-button>
  </actions-container>
</ng-template>

<ng-template #objectContentTemplate let-content=content>
  <div>
    <quick-preview-panel
      [heading]="heading || 'Result'"
      [color]="color || 'primary'"
      [ngClass]="'mb-4'"
    >
      <div>
        <div class="min-height-120 px-4 pt-4 overflow-hidden">
          <div class="overflow-auto bg-body-tertiary"><pre>{{content | json}}</pre></div>
        </div>
      </div>
      <actions-container [ngClass]="'px-4'">
        <back-button [ngClass]="'ms-2'"></back-button>
      </actions-container>
    </quick-preview-panel>
  </div>
</ng-template>
